<template>
  <div>
    <v-select
      v-model="grade_volume_id"
      class="px-2"
      :items="gradeVolumes"
      item-text="name"
      item-value="id"
      label="Volumes"
      :disabled="gradeVolumes.length === 0"
    >
      <template
        v-if="grade_volume_id !== null"
        #append
      >
        <v-btn
          color="primary"
          text
          @click="grade_volume_id = null"
        >
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-select>
  </div>
</template>

<script>
import handlesServerValidation from '@/mixins/handles-server-validation.js'
export default {
  mixins: [
    handlesServerValidation
  ],
  props: {
    gradeId: { type: Number, default: undefined },
    gradeVolumeIdSelected: { type: Number, default: undefined }
  },
  data: () => ({
    gradeVolumes: [],
    grade_volume_id: null
  }),
  watch: {
    grade_volume_id () {
      this.setGradeVolume()
    },
    async gradeId () {
      if (this.gradeId) {
        await this.listGradeVolumes()
        this.gradeVolumes.find(gradeVolume => gradeVolume.id === this.gradeVolumeIdSelected) && (this.grade_volume_id = this.gradeVolumeIdSelected)
      } else {
        this.gradeVolumes = []
        this.grade_volume_id = null
        this.setGradeVolume()
      }
    }
  },

  methods: {
    setGradeVolume () {
      this.$emit('setGradeVolume', this.grade_volume_id)
    },
    async listGradeVolumes () {
      try {
        this.gradeVolumes = await this.$api.listGradeVolumes(this.gradeId)
        this.grade_volume_id = null
      } catch (e) {
        this.getErrors(e)
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível obter os volumes, tente novamente mais tarde.', color: 'red' })
      }
    }
  }
}
</script>
